import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { styles } from "./styles";
import { handleUpdate } from "../../services/eventService";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { useContext, useEffect, useState } from "react";
import { AuthContext, AuthContextInterface } from "../../contexts";
import { EventType } from "../../proto/api_pb";
import { NotificationCardProps } from "./types";
import { TEXT_COLOR } from "../../theme";

export const NotificationCard: React.FC<NotificationCardProps> = ({
  notification,
  updateDismiss,
}) => {
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const [trackTitle, setTrackTitle] = useState<string>();
  const [eventCreatorName, setEventCreatorName] = useState<string>();
  const { getValidAccessToken } = useGetValidAccessToken();
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const getEventTitle = (eventType: number): React.ReactNode => {
    if (eventType === EventType.NEW_COLLABORATOR_ADDED) {
      return `${eventCreatorName} added a new collaborator to ${trackTitle}`;
    } else if (eventType === EventType.NEW_VERSION_ADDED) {
      return `${eventCreatorName} added a new Version to ${trackTitle} track`;
    } else if (eventType === EventType.TRACK_PUBLISHED) {
      return `${eventCreatorName} change privacy of ${trackTitle} track`;
    } else if (eventType === EventType.TRACK_STATUS_UPDATED) {
      return `${eventCreatorName} update status of ${trackTitle} track`;
    }
  };

  const getTimestampToDate = (timeStamp: number, isExpiryTime?: boolean) => {
    const date = isExpiryTime
      ? new Date(timeStamp)
      : new Date(timeStamp * 1000);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${month}/${day}/${year} ${formattedHours}:${formattedMinutes} ${amPm}`;
  };

  useEffect(() => {
    setTrackTitle(notification.getTrackTitle());
    setEventCreatorName(notification.getCreatorUserName());
  }, [notification]);

  return (
    <>
      {eventCreatorName &&
        trackTitle &&
        notification.getEventCreatedBy() !== userId && (
          <Box sx={styles.container} onClick={(e) => e.stopPropagation()}>
            <Box sx={styles.dateContainer}>
              <Typography sx={{ fontSize: "12px" }}>
                {getTimestampToDate(notification.getTimestamp())}
              </Typography>
            </Box>
            <Box>
              <Typography>
                {getEventTitle(notification.getEventType())}
              </Typography>
              <Box sx={styles.actionContainer}>
                <Button
                  sx={styles.skipButton}
                  onClick={async () => {
                    setUpdateLoading(true);
                    await handleUpdate(
                      notification.getId(),
                      userId,
                      await getValidAccessToken()
                    );
                    updateDismiss(notification.getId());
                    setUpdateLoading(false);
                  }}
                >
                  {updateLoading ? (
                    <CircularProgress
                      size={"15px"}
                      sx={{ color: TEXT_COLOR }}
                    />
                  ) : (
                    "Dismiss"
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        )}
    </>
  );
};
